var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("BaseModalWrapper", {
        attrs: { size: "l", show: _vm.showAd },
        on: {
          close: function ($event) {
            _vm.showAd = false
          },
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex align-items-center nordic-championships-campaign-container rin-nordic-championships-campaing-wrapper",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "p-4" },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to:
                                "/en/tournament/47618/nordic-team-championships-drammen-norway",
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "img-fluid",
                              attrs: {
                                src:
                                  "https://cdn.rankedin.com/images/static/campaign/nordic-championships-campaign.jpeg",
                                alt: "nordic-championships campaign image",
                              },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }